import React, { useState } from 'react';
import styled from 'styled-components';
import { IoIosClose } from 'react-icons/io';
import { MdAdd } from 'react-icons/md';
import LoadStepTwo from './LoadStepTwo';
import LoadProgramStepTwo from './LoadProgramStepTwo';
import LoadModalSearchContainer from '../../containers/prescription/LoadModalSearchContainer';
import LoadStepThree from './LoadStepThree';
import LoadProgramStepThree from './LoadProgramStepThree';
import palette from '../../lib/styles/palette';
import ProgramRegistContainer from '../../containers/prescription/ProgramRegistContainer';

const FullScreen = styled.div`
  position: fixed;
  z-index: 30;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.25);
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`;

const AskModalBlock = styled.div`
  width: 50%;
  height: 80vh;
  background: #fff;
  padding: 1.5rem;
  border-radius: 4px;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.125);
  position: relative;
  display: flex;
  flex-direction: column;
  h2 {
    margin-top: 0;
    /* margin-bottom: 1rem;*/
  }
  p {
    margin-bottom: 3rem;
  }
  .buttons {
    display: flex;
    justify-content: flex-end;
  }

  @media screen and (max-width: 720px) {
      position: absolute;
      top: 60px;
  }
`;
const CloseBlock = styled.div`
  position: absolute;
  right: -20px;
  top: 2px;

  svg {
    cursor: pointer;
    font-size: 2.5rem;
  }
`;
const Top = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0px;
  margin-bottom: 20px;
  border-bottom: 1px solid ${palette.webGray[15]};
`;

const TabGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;

  & div {
    font-size: 1.2rem;
    color: ${palette.webGray[6]};
    cursor: pointer;

    &.active {
      color: ${palette.webCyan[5]};
      font-weight: bold;
    }
  }
`;

const ContentWrapper = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  position: relative;
  padding-bottom: 80px;
`;

const AddProgramButton = styled.button`
  position: absolute;
  bottom: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 24px;
  background-color: #1976d2;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.3);
  z-index: 10;

  &:hover {
    background-color: #1565c0;
    box-shadow: 0 4px 12px rgba(25, 118, 210, 0.4);
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }

  svg {
    font-size: 20px;
  }
`;

const ProgramModalCloseBlock = styled.div`
  position: absolute;
  right: 16px;
  top: 16px;

  svg {
    cursor: pointer;
    font-size: 2.5rem;
    color: #666;
    
    &:hover {
      color: #333;
    }
  }
`;

const FCLoadModal = ({
  onClose,
  visible,
  prescriptions,
  onLoadClubProgram,
  step,
  loading,
  onSetStep,
  onTempSetProgram,
  tempLoadProgram,
  loadMode,
  onLoadFcClubProgram,
  setLoadMode,
  onDeleteProgram,
}) => {
  const [showProgramRegist, setShowProgramRegist] = useState(false);

  if (!visible) return null;
  
  return (
    <FullScreen>
      <AskModalBlock>
        <Top>
          <TabGroup>
            <div className={loadMode === "program" ? "active" : ""} onClick={() => {if(loadMode !== "program") {
              setLoadMode("program");
              onLoadFcClubProgram();
              onSetStep(1);
            }}}>프로그램</div>
            <div className={loadMode === "prescription" ? "active" : ""} onClick={() => {if(loadMode !== "prescription") {
              setLoadMode("prescription");
              onSetStep(1);
            }}}>회원 처방</div>
          </TabGroup>
          <CloseBlock>
            <IoIosClose onClick={() => onClose('load')} />
          </CloseBlock>
        </Top>
        {loadMode === "program" && step === 1 && (
          <AddProgramButton onClick={() => setShowProgramRegist(true)}>
            <MdAdd />
            프로그램 추가
          </AddProgramButton>
        )}
        <ContentWrapper>
          {loadMode === "program" ?
            <>
              {step === 1 ? (
                <LoadProgramStepTwo
                  prescriptions={prescriptions}
                  onSetStep={onSetStep}
                  onTempSetProgram={onTempSetProgram}
                  loading={loading}
                  onDeleteProgram={onDeleteProgram}
                />
              ) : (
                <LoadProgramStepThree
                  onLoadClubProgram={onLoadClubProgram}
                  program={tempLoadProgram}
                  onSetStep={onSetStep}
                />
              )}
            </>
          :
            <>
              {step === 1 ? (
                <LoadModalSearchContainer />
              ) : step === 2 ? (
                <LoadStepTwo
                  prescriptions={prescriptions}
                  onSetStep={onSetStep}
                  onTempSetProgram={onTempSetProgram}
                  loading={loading}
                />
              ) : (
                <LoadStepThree
                  onLoadClubProgram={onLoadClubProgram}
                  program={tempLoadProgram}
                  onSetStep={onSetStep}
                />
              )}
            </>
          }
        </ContentWrapper>
      </AskModalBlock>
      
      {showProgramRegist && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 40,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px'
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '16px',
            maxWidth: '1400px',
            maxHeight: '90vh',
            width: '100%',
            overflow: 'auto',
            position: 'relative'
          }}>
            <ProgramModalCloseBlock>
              <IoIosClose onClick={() => setShowProgramRegist(false)} />
            </ProgramModalCloseBlock>
            <ProgramRegistContainer onClose={(reload) => {
              setShowProgramRegist(false);
              if (reload) {
                onLoadFcClubProgram();
              }
            }} />
          </div>
        </div>
      )}
    </FullScreen>
  );
};

export default FCLoadModal;
